export const LOCAL_STORAGE_KEYS = {
  USER_SELECTED_WAREHOUSE: "UserSelectedWarehouse",
  USER_SELECTED_OPPORTUNITY: "UserSelectedOpportunity",
  DEFAULT_START_DATE: "DefaultStartDate",
  DEFAULT_END_DATE: "DefaultEndDate",
} as const;

function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch (error) {
    console.error(`Error reading from localStorage for key "${key}":`, error);
    return null;
  }
}

function safeSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.error(`Error writing to localStorage for key "${key}":`, error);
  }
}

export function setUserSelectedWarehouse(warehouseCode: string) {
  safeSetItem(LOCAL_STORAGE_KEYS.USER_SELECTED_WAREHOUSE, warehouseCode);
}

export function getUserSelectedWarehouse() {
  return safeGetItem(LOCAL_STORAGE_KEYS.USER_SELECTED_WAREHOUSE) || "MTL";
}

export function setUserSelectedOpportunity(bidNumber: string) {
  safeSetItem(LOCAL_STORAGE_KEYS.USER_SELECTED_OPPORTUNITY, bidNumber);
}

export function getUserSelectedOpportunity() {
  return safeGetItem(LOCAL_STORAGE_KEYS.USER_SELECTED_OPPORTUNITY);
}

export function getDefaultStartDate() {
  return safeGetItem(LOCAL_STORAGE_KEYS.DEFAULT_START_DATE) ?? undefined;
}

export function setDefaultStartDate(startDate: string) {
  safeSetItem(LOCAL_STORAGE_KEYS.DEFAULT_START_DATE, startDate);
}

export function getDefaultEndDate() {
  return safeGetItem(LOCAL_STORAGE_KEYS.DEFAULT_END_DATE) ?? undefined;
}

export function setDefaultEndDate(endDate: string) {
  safeSetItem(LOCAL_STORAGE_KEYS.DEFAULT_END_DATE, endDate);
}
